import React from 'react';
import styled from 'styled-components';

import { animation } from '../../config';
import FieldError from './field-error';
import FieldLabel from './field-label';

export const InputElement = styled.input`
  display: block;
  width: 100%;
  background: #ebebeb;
  border-radius: 8px;
  border: none;
  padding: 10px 14px;
  transition: ${animation.transition};
  font-size: 16px;

  &:focus {
    background: #dedede;
  }
`;

export default function Input({ name, label, type, form, ...rest }) {
  return (
    <>
      <FieldLabel htmlFor={name}>{label}</FieldLabel>
      <InputElement id={name} name={name} type={type} {...rest} />
      <FieldError error={form.errors[name]} htmlFor={name} />
    </>
  );
}
